/*
 * @Author: Wang_jun 1433207604@qq.com
 * @Date: 2022-03-02 15:28:27
 * @LastEditors: Wang_jun 1433207604@qq.com
 * @LastEditTime: 2024-05-09 16:14:53
 * @FilePath: /visaai-platform/src/plugins/store/types.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const SET_USER_INFO = 'SET_USER_INFO'

export const SET_BALANCE = 'SET_BALANCE'

export const SET_DOWNLOAD_NUM = 'SET_DOWNLOAD_NUM'